import { render } from "./EventFormView.vue?vue&type=template&id=1fcd2e3e"
import script from "./EventFormView.vue?vue&type=script&lang=js"
export * from "./EventFormView.vue?vue&type=script&lang=js"

import "./EventFormView.vue?vue&type=style&index=0&id=1fcd2e3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__